import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo';

import CategoryGql from '@/extensions/shop/store/graphql/queries/Category.gql';
import CategoriesGql from '@/extensions/shop/store/graphql/queries/Categories.gql';
import SaveCategoriesGql from '@/extensions/shop/store/graphql/mutations/SaveCategories.gql';

export default {
    fetchItem: id =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: CategoryGql,
                    variables: {
                        id: parseInt(id)
                    }
                })
                .then(({ data }) => resolve(data.CO_Category))
                .catch(err => reject(err));
        }),
    fetchList: (shopID = null) => {
        return new Promise((resolve, reject) => {
            let variables = {};
            if (shopID) variables.shop = parseInt(shopID);

            apolloClient
                .query({
                    query: CategoriesGql,
                    variables
                })
                .then(({ data }) => resolve(data.CO_Categories))
                .catch(err => reject(err));
        });
    },
    saveAll: (categories, shopID) => {
        categories = _.removeDeepByKey(categories, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: SaveCategoriesGql,
                    variables: {
                        shop: parseInt(shopID),
                        categories
                    }
                })
                .then(({ data }) => resolve(data.CO_SaveCategories))
                .catch(err => reject(err));
        });
    }
};
